interface NavigatorUA extends Navigator {
  userAgentData?: {
    platform?: string;
  };
}

function getPlatform(): string {
  const uaData = (navigator as NavigatorUA).userAgentData;
  if (uaData?.platform) return uaData.platform;
  return navigator.platform;
}

let scrollLockCount = 0;

export function lockScroll() {
  const isIOS = /iP(hone|ad|od)|iOS/.test(getPlatform());
  const bodyStyle = document.body.style;
  // RTL <body> scrollbar
  const scrollbarX =
    Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
  const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
  const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
  bodyStyle.overflow = 'hidden';
  if (scrollbarWidth) bodyStyle[paddingProp] = `${scrollbarWidth}px`;
  // Only iOS doesn't respect `overflow: hidden` on document.body, and this
  // technique has fewer side effects.
  if (isIOS) {
    // iOS 12 does not support `visualViewport`.
    const offsetLeft = window.visualViewport?.offsetLeft || 0;
    const offsetTop = window.visualViewport?.offsetTop || 0;
    Object.assign(bodyStyle, {
      position: 'fixed',
      top: `${-(scrollY - Math.floor(offsetTop))}px`,
      left: `${-(scrollX - Math.floor(offsetLeft))}px`,
      right: '0',
    });
  }
  scrollLockCount += 1;

  return () => {
    scrollLockCount -= 1;
    // 마지막 스크롤 lock 된것이 꺼질때만 동작하도록
    if (scrollLockCount > 0) return;
    Object.assign(bodyStyle, {
      overflow: '',
      [paddingProp]: '',
    });
    if (isIOS) {
      Object.assign(bodyStyle, {
        position: '',
        top: '',
        left: '',
        right: '',
      });
      window.scrollTo(scrollX, scrollY);
    }
  };
}
